// i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';

// 1. 使用 i18n 插件
Vue.use(VueI18n);

// 2. 定义翻译信息
import en from '../locales/en.json';
import pt from '../locales/pt.json';
import zh from '../locales/zh.json';

const messages = {
  en,
  zh,
  pt
};


// 3. 创建 i18n 实例
const i18n = new VueI18n({
  locale: 'en', // 设置默认语言
  fallbackLocale: 'en', // 设置回退语言
  messages, // 设置翻译信息
});

export default i18n;
